<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="2" @click="toNewRouter('questionnaire-template-manage')" v-if="permissionCodes.indexOf('035001000') !== -1">
        <i class="el-icon-damai-ic_mobanguanli"></i>
        <span slot="title">模板管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('questionnaire-project-manage')" v-if="permissionCodes.indexOf('035002000') !== -1">
        <i class="el-icon-damai-ic_xiangmuguanli"></i>
        <span slot="title">项目管理</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('questionnaire-publishment-manage')" v-if="permissionCodes.indexOf('035003000') !== -1">
        <i class="el-icon-damai-ic_xiangmufabu"></i>
        <span slot="title">项目发布</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('questionnaire-log')" v-if="permissionCodes.indexOf('035004000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  "1": ["Template management"],
  "2": [
    "questionnaire-template-manage",
    "questionnaire-template-add",
    "questionnaire-template-modify"
  ],
  "3": [
    "questionnaire-project-manage",
    "questionnaire-project-add",
    "questionnaire-project-modify"
  ],
  "4": [
    "questionnaire-publishment-manage",
    "questionnaire-publishment-add",
    "questionnaire-publishment-modify"
  ],
  "5": ["questionnaire-log"]
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Questionnaire/QuestionnaireNav.vue